var map = {
	"./dict.js": "qitd",
	"./faceCompare.js": "JeNs",
	"./imgstore.js": "efWE",
	"./payParams.js": "wShz",
	"./user.js": "bREw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YkTy";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules .js$
// module id = YkTy
// module chunks = 78